module.exports = __webpack_public_path__ + "img/icons.0c270eedd091c5936089aabc72b299ab.svg";